export const createColumnDefs = (data, properties) => {
    const headers = data && data.length > 0 ? data[0] : [];
    return headers.map(header => {

        //add extra attributes for controlled anotate item
        let extra = { cellEditor: 'simpleEditor' };
        const annotateItem = properties.find(prop => prop.annotate && prop.label === header);
        if (annotateItem) {
            extra = {
                cellEditor: 'agSelectCellEditor',
                cellEditorParams: {
                    values: annotateItem.annotate.list,
                },
            };
        }
        // custom editors for specific columns
        if (header === 'supplier_name') {
            extra = {
                cellEditor: 'suppliersEditor',
            };
        } else if (header === 'hazard') {
            extra = {
                cellEditor: 'hazardsEditor',
            };
        } else if (header === 'product') {
            extra = {
                cellEditor: 'productsEditor',
            };
        } else if (header === 'origin') {
            extra = {
                cellEditor: 'originsEditor',
            };
        }

        return {
            headerName: header,
            field: header,
            ...extra,
        };
    });
};

export const formatDataForReactAggrid = (data, { properties }) => {
    const output = {
        columnDefs: [],
        rowData: [],
    };
    let curRow = [];
    let rows = [];
    let columns = createColumnDefs(data, properties);

    if (columns.length > 0) {
        for (var i = 1; i < data.length; i++) {
            curRow = {};
            var count = 0;
            data[i].forEach(item => {
                curRow[columns[count].field] = { displayValue: item };
                count++;
            });
            if (curRow != {}) {
                rows.push(curRow);
            }
        }
    } else {
        alert("The specific sheet does not provide column names in the first row. Therefore, it can't be proccessed");
    }
    output.columnDefs = columns;
    output.rowData = rows;
    return output;
};

export const formatDataForXLSX = input => {
    let curRow = [];
    let output = [];
    let columnDefs = input.columnDefs;
    let rowData = input.rowData;
    console.log(rowData)
    columnDefs.forEach(column => {
        curRow.push(column.headerName);
    });
    output.push(curRow);
    rowData.forEach(row => {
        curRow = [];
        for (var col in row) {
            curRow.push(row[col].displayValue);
        }
        console.log(curRow, row)
        output.push(curRow);
    });
    return output;
};
